import { systemCode } from "../..";
import { getConfiguration } from "../utils/configuration";

const baseConfig = {
    backgroundColor: '#111',
    showStatusImage: true,
    showLogoHeader: true,
    showDate: true,
    showDomain: true,
    showTicketHeader: false,
    showInfoTkt: true,
    showStatusBar: true,
    showBottomStats: false,
    showFooter: true,
    showFooterLogo: true,
    showFooterLegal: true,
    showFooterIcons: true,
    containerClass: '',
    backgrounds: [],
    defaultBackgroundId: null,
};

// Sfondo di fallback quando conf.sbb non è configurato
const BG_FALLBACK = [{ id: 'default', color: '#111111', imageUrl: null }];

function getBackgroundsFromConf() {
    const conf = getConfiguration();
    try {
        const parsed = conf.sbb ? JSON.parse(conf.sbb) : null;
        if (!parsed?.length) return BG_FALLBACK;
        return parsed.map((bg, i) => ({ id: `bg_${i}`, ...bg }));
    } catch {
        return BG_FALLBACK;
    }
}

const BRAND_CONFIGS = {

    DOMUSBET: {
        ...baseConfig,
    },

    BETSSON: {
        ...baseConfig,
        backgroundColor: '#FF6600',
        showStatusImage: false,
        showLogoHeader: true,
        showDate: false,
        showDomain: false,
        showTicketHeader: true,
        showInfoTkt: false,
        showStatusBar: false,
        showBottomStats: true,
        showFooter: false,
        showFooterLogo: false,
        showFooterLegal: false,
        showFooterIcons: false,
        containerClass: 'share-card--betsson',
        // backgrounds e defaultBackgroundId sono getter e vengono ricalcolati ad ogni accesso, così leggono conf.sbb dopo che la configurazione è caricata
        get backgrounds() {
            return getBackgroundsFromConf();
        },
        get defaultBackgroundId() {
            return getBackgroundsFromConf()[0].id;
        },
    },
      SPORTBET: {
        ...baseConfig,
        backgroundColor: '#ec6728',
        showStatusImage: false,
        showLogoHeader: true,
        showDate: false,
        showDomain: false,
        showTicketHeader: true,
        showInfoTkt: false,
        showStatusBar: false,
        showBottomStats: true,
        showFooter: false,
        showFooterLogo: false,
        showFooterLegal: false,
        showFooterIcons: false,
        containerClass: 'share-card--sportbet',
        get backgrounds() {
            return getBackgroundsFromConf();
        },
        get defaultBackgroundId() {
            return getBackgroundsFromConf()[0].id;
        },
    },
    BETPREMIUM: {
        ...baseConfig,
        backgroundColor: '#e4b30e ',
        showStatusImage: false,
        showLogoHeader: true,
        showDate: false,
        showDomain: false,
        showTicketHeader: true,
        showInfoTkt: false,
        showStatusBar: false,
        showBottomStats: true,
        showFooter: false,
        showFooterLogo: false,
        showFooterLegal: false,
        showFooterIcons: false,
        containerClass: 'share-card--sunbet',
        get backgrounds() {
            return getBackgroundsFromConf();
        },
        get defaultBackgroundId() {
            return getBackgroundsFromConf()[0].id;
        },
    },

};

export const getShareCardConfig = () => {
    return BRAND_CONFIGS[systemCode] || baseConfig;
};